import { Outlet } from 'react-router-dom';
import Navbar from './navbar';
import Passeio from './passeio';

const Layout = () => {
  return (
    <>
      <Passeio></Passeio>
      <Navbar/>
      <main>
        <Outlet/>
      </main>
    </>
  );
};

export default Layout;